import { useCallback, useEffect } from "react";

import useService from "../../../../hooks/useService";
import ApiRequestErrorHandler from "../../../global/ApiRequestErrorHandler";
import { usePaymentStore } from "../store/paymentStore";

export default function usePaymentsData({ entityId, enabled = true } = {}) {
  const paymentsRepository = useService("repositories/payment-repository");
  const { data, loading, currentPage, resLimit, setData, setLoading, setResultCount } =
    usePaymentStore();

  const fetchPaymentsData = useCallback(async () => {
    if (!enabled) {
      setData([]);
      setResultCount(0);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const queryParams = {};

      if (resLimit && currentPage) {
        queryParams.limit = resLimit;
        queryParams.offset = (Number(currentPage) - 1) * resLimit || 0;
      }

      if (entityId) {
        queryParams.entity = entityId;
      }

      const response = await paymentsRepository.query(queryParams);
      const count = await paymentsRepository.getTotalCount();
      setData(response ?? []);
      setResultCount(count);
    } catch (error) {
      ApiRequestErrorHandler(error);
    } finally {
      setLoading(false);
    }
  }, [
    currentPage,
    enabled,
    entityId,
    paymentsRepository,
    resLimit,
    setData,
    setLoading,
    setResultCount,
  ]);

  useEffect(() => {
    fetchPaymentsData();
  }, [fetchPaymentsData]);

  return {
    data,
    fetchPaymentsData,
    loading,
  };
}
